import { render, staticRenderFns } from "./NiifNotas.vue?vue&type=template&id=27545476"
import script from "./NiifNotas.vue?vue&type=script&lang=js"
export * from "./NiifNotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports